import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

import Image from 'next/image'

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  borderRadius: 1,
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover
}))

const WhatsappContacts = props => {
  // ** Props
  const {
    data,
    store,
    hidden,
    sendMsg,
    mdAbove,
    dispatch,
    getInitials,
    sidebarWidth,
    callData,
    userProfileRightOpen,
    handleLeftSidebarToggle,
    handleUserProfileRightSidebarToggle,
    setContacts
  } = props

  const handleStartConversation = () => {
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const renderContent = () => {
    if (store) {
      const selectedMessage = store.selectedMessage

      if (!selectedMessage) {
        return (
          <ChatWrapperStartChat
            sx={{
              ...(mdAbove ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : {})
            }}
          >
            <Box
              onClick={handleStartConversation}
              sx={{
                px: 6,
                py: 2.25,
                boxShadow: 3,
                borderRadius: 5,
                backgroundColor: 'background.paper',
                cursor: mdAbove ? 'default' : 'pointer'
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>Start Conversation</Typography>
            </Box>
          </ChatWrapperStartChat>
        )
      } else {
        return (
          <>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                height: '100%',
                backgroundColor: 'white'
              }}
            >
              <Box
                sx={{
                  py: 3,
                  px: 5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: theme => `1px solid ${theme.palette.divider}`,
                  backgroundColor: '#',
                  height: 50
                }}
                className='border-b-[1px]'
              >

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {mdAbove ? null : (
                    <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2 }}>
                      <Icon icon='mdi:menu' />
                    </IconButton>
                  )}

                  <Box
                    onClick={handleUserProfileRightSidebarToggle}
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                  >

                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography sx={{ color: 'text.secondary', fontWeight: 700, color: 'black' }}>Contacts</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <div className='overflow-auto h-[89%] bg-white '>
                <div className='grid grid-cols-4 gap-y-4 w-11/12 mx-auto mt-4 sm:grid-cols-2'>
                  {callData.contacts.map(item => {
                    return (
                      <div key={item.id} className='bg-white rounded-lg h-[150px] w-5/6 items-center grid shadow-2xl'>
                        <div className='flex items-center justify-center'>
                          <Image src={item.img} alt='img' width={55} height={55} className=' rounded-full' />
                        </div>
                        <div className='flex items-center justify-center  text-[14px]'>
                          <h2 className='font-bold'>{item.name}</h2>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

              {/* <SendMsgForm store={store} dispatch={dispatch} sendMsg={sendMsg} /> */}
            </Box>
          </>
        )
      }
    } else {
      return null
    }
  }

  return renderContent()
}

export default WhatsappContacts
